export default __webpack_public_path__ + "media/flags/es-e41ce34b.svg";